"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "account-confirm-content" };
const _hoisted_2 = { class: "oplus-form-checkbox account-confirm-selection" };
const _hoisted_3 = { class: "account-login" };
const _hoisted_4 = ["href"];
const vue_3 = require("vue");
const Modal_vue_1 = __importDefault(require("./Modal.vue"));
const AccountIcon_vue_1 = __importDefault(require("../view/assets/icons/AccountIcon.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'AccountCreationConfirmModal',
    props: {
        loginUrl: {
            type: String,
            default: '',
        },
    },
    emits: ["confirm"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const isVisible = (0, vue_3.ref)(false);
        const isloading = (0, vue_3.ref)(false);
        const isAccountCreationConfirmed = (0, vue_3.ref)(false);
        function openModal() {
            if (!isloading.value) {
                isAccountCreationConfirmed.value = false;
                isVisible.value = true;
            }
        }
        function closeModal() {
            if (!isloading.value) {
                isVisible.value = false;
            }
        }
        function confirm() {
            if (isloading.value || !isAccountCreationConfirmed.value) {
                return;
            }
            isloading.value = true;
            emit('confirm');
        }
        const confirmButtonClass = (0, vue_3.computed)(() => {
            return {
                loading: isloading.value,
                'disabled-btn': !isAccountCreationConfirmed.value,
            };
        });
        __expose({ openModal, closeModal });
        return (_ctx, _cache) => {
            return (isVisible.value)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                    key: 0,
                    "modal-name": "account-creation-confirm-modal",
                    "include-modal-footer": false,
                    onCloseModal: closeModal,
                    onCancel: closeModal
                }, {
                    content: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_1, [
                            (0, vue_2.createVNode)(AccountIcon_vue_1.default, { class: "oplus-color" }),
                            _cache[5] || (_cache[5] = (0, vue_2.createElementVNode)("div", { class: "account-confirm-title" }, "oplusの新しいアカウントを作成しますか？", -1 /* CACHED */)),
                            _cache[6] || (_cache[6] = (0, vue_2.createElementVNode)("p", { class: "account-confirm-description" }, " 20,000社以上の企業に選ばれているoplusで、業務を効率化しましょう。 ", -1 /* CACHED */)),
                            (0, vue_2.createElementVNode)("label", _hoisted_2, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isAccountCreationConfirmed).value = $event)),
                                    type: "checkbox"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelCheckbox, isAccountCreationConfirmed.value]
                                ]),
                                _cache[1] || (_cache[1] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */)),
                                _cache[2] || (_cache[2] = (0, vue_2.createElementVNode)("span", null, "新しい会社アカウントを作成する。", -1 /* CACHED */))
                            ]),
                            (0, vue_2.createElementVNode)("button", {
                                class: (0, vue_2.normalizeClass)(["oplus-modal-btn oplus-alt-confirm-btn account-confirm-submit", confirmButtonClass.value]),
                                type: "button",
                                onClick: confirm
                            }, " 会社のアカウントを新規作成！ ", 2 /* CLASS */),
                            (0, vue_2.createElementVNode)("p", _hoisted_3, [
                                _cache[3] || (_cache[3] = (0, vue_2.createTextVNode)(" すでにご利用中の方は ", -1 /* CACHED */)),
                                (0, vue_2.createElementVNode)("a", { href: __props.loginUrl }, "こちら", 8 /* PROPS */, _hoisted_4),
                                _cache[4] || (_cache[4] = (0, vue_2.createTextVNode)("をクリック ", -1 /* CACHED */))
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }))
                : (0, vue_2.createCommentVNode)("v-if", true);
        };
    }
});
